import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import CEODesk from "./pages/CEODesk";
import VisionMission from "./pages/VisionMission";
import Services from "./pages/Services";
import ServiceOfferPlan from "./pages/ServiceOfferPlan";
import HowItWorks from "./pages/HowItWorks";
import WhyChoose from "./pages/WhyChoose";
import WhoWeServe from "./pages/WhoWeServe";
import Booking from "./pages/Booking";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import Careers from "./pages/Careers";

// Layout wrapper
const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">{children}</main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/ceo-desk" element={<CEODesk />} />
            <Route path="/vision-mission" element={<VisionMission />} />
            <Route path="/services" element={<Services />} />
            <Route path="/service-offer-plan" element={<ServiceOfferPlan />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/why-choose" element={<WhyChoose />} />
            <Route path="/who-we-serve" element={<WhoWeServe />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/careers" element={<Careers />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
